module.exports = __webpack_public_path__ + "img/BlinkArt_Sword15_Earth.7bf8ec1c.png";